module.exports = __webpack_public_path__ + "0dcfb9e1fa3fe73f6b2ce67899b2b411.jpg";